import { getErrorWithResponse } from './getErrorWithResponse.ts';

export function throwErrorWithResponse(error: any, response: Response): never {
	throw getErrorWithResponse(error, response);
}
